import { useState, useEffect } from 'react'

const DISMISSED_KEY = 'e4f_install_dismissed'

function isIOS() {
  return /iphone|ipad|ipod/i.test(navigator.userAgent) && !window.MSStream
}

function isInStandaloneMode() {
  return window.matchMedia('(display-mode: standalone)').matches || window.navigator.standalone === true
}

export default function InstallPrompt() {
  const [deferredPrompt, setDeferredPrompt] = useState(null)
  const [showIOS, setShowIOS]               = useState(false)
  const [visible, setVisible]               = useState(false)

  useEffect(() => {
    if (isInStandaloneMode()) return
    if (localStorage.getItem(DISMISSED_KEY)) return

    if (isIOS()) {
      setShowIOS(true)
      setVisible(true)
      return
    }

    const handler = (e) => {
      e.preventDefault()
      setDeferredPrompt(e)
      setVisible(true)
    }
    window.addEventListener('beforeinstallprompt', handler)
    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  function dismiss() {
    localStorage.setItem(DISMISSED_KEY, '1')
    setVisible(false)
  }

  async function install() {
    if (!deferredPrompt) return
    deferredPrompt.prompt()
    const { outcome } = await deferredPrompt.userChoice
    if (outcome === 'accepted') setVisible(false)
    setDeferredPrompt(null)
  }

  if (!visible) return null

  return (
    <div style={{
      position: 'fixed', bottom: 24, left: '50%', transform: 'translateX(-50%)',
      zIndex: 9999, width: 'min(360px, calc(100vw - 32px))',
      background: 'var(--bg-surface)', border: '1px solid var(--border)',
      borderRadius: 14, boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
      padding: '14px 16px', display: 'flex', alignItems: 'flex-start', gap: 12,
    }}>
      <div style={{
        width: 40, height: 40, borderRadius: 10, overflow: 'hidden', flexShrink: 0,
        background: '#3b82f6', display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}>
        <img src="/icons/pwa-192x192.png" style={{ width: 40, height: 40 }} alt="" />
      </div>

      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontWeight: 600, fontSize: 14, color: 'var(--text-primary)', marginBottom: 2 }}>
          Install Edge4Field
        </div>
        <div style={{ fontSize: 12, color: 'var(--text-secondary)', lineHeight: 1.4 }}>
          {showIOS
            ? <>Tap <strong>Share</strong> then <strong>Add to Home Screen</strong> to install.</>
            : 'Add to your home screen for the best experience.'}
        </div>

        {!showIOS && (
          <button onClick={install} style={{
            marginTop: 10, padding: '6px 14px', borderRadius: 8,
            background: 'var(--accent)', color: 'var(--accent-text)',
            border: 'none', fontSize: 13, fontWeight: 600, cursor: 'pointer',
          }}>
            Install
          </button>
        )}
      </div>

      <button onClick={dismiss} style={{
        background: 'none', border: 'none', cursor: 'pointer',
        color: 'var(--text-muted)', fontSize: 18, lineHeight: 1, padding: 2, flexShrink: 0,
      }}>×</button>
    </div>
  )
}
